import { useMutation } from '@tanstack/react-query';
import Notify from '@/components/Notification';
import { markRefreshSessionHint } from '@/helpers/authSession';
import { useUserStore } from '@/store/userStore';
import { CONTACT_EMAIL } from '@/helpers/constants';
import { getMessage } from '@/helpers/utils';
import { userService } from '../../services/userService';

export const useLoginUser = () => {
  return useMutation({
    mutationFn: payload =>
      userService.loginUser(payload).then(response => {
        const { status, data } = response;
        const message = getMessage(data);

        if (status === 200) {
          markRefreshSessionHint();
          useUserStore.getState().setAccessToken(data.access_token);
          window.gtag &&
            window.gtag('event', 'send', {
              event_category: 'form',
              event_label: 'founder_login',
            });
          return { success: true, data };
        }

        message && !message.includes(CONTACT_EMAIL) && Notify.error({ text: message });

        if (status === 400) {
          return { success: false, message: data.message };
        }

        return null;
      }),
  });
};
